(() => {
  if (window.glowBackDisplayLoaded) return;
  window.glowBackDisplayLoaded = true;
  function init(root) {
    if (root.dataset.ready) return;
    const canvas = root.querySelector('canvas');
    if (!canvas) return;
    root.dataset.ready = 'true';
    const ctx = canvas.getContext('2d');
    const source = document.createElement('canvas');
    source.width = source.height = 64;
    const c = source.getContext('2d', {willReadFrequently:true});
    const leds = document.createElement('canvas');
    leds.width = leds.height = 512;
    const light = leds.getContext('2d');
    const status = root.querySelector('.gb-status');
    const power = root.querySelector('.gb-power');
    const input = root.querySelector('input[type=file]');
    const remove = root.querySelector('.gb-remove');
    let powered = true, uploadVersion = 0;
    function render() {
      const pixels = c.getImageData(0,0,64,64).data;
      light.clearRect(0,0,512,512);
      for (let y=0;y<64;y++) for(let x=0;x<64;x++) {
        const i=(y*64+x)*4, raw=[pixels[i],pixels[i+1],pixels[i+2]], peak=Math.max(...raw);
        if(peak<8) continue;
        const gain=Math.min(255,255*Math.pow(peak/255,.78)*1.06)/peak;
        const rgb=raw.map(v=>Math.min(255,Math.round(v*gain)));
        const px=x*8+4,py=y*8+4;
        light.fillStyle=`rgb(${rgb.join(',')})`;
        light.beginPath();light.arc(px,py,3.45,0,Math.PI*2);light.fill();
        light.fillStyle=`rgb(${rgb.map(v=>Math.round(v+(255-v)*.33)).join(',')})`;
        light.beginPath();light.arc(px,py,1.65,0,Math.PI*2);light.fill();
      }
      ctx.fillStyle='#020304';ctx.fillRect(0,0,512,512);
      if(powered){
        ctx.save();ctx.globalAlpha=.4;ctx.filter='blur(6px)';ctx.drawImage(leds,0,0);ctx.restore();
        ctx.drawImage(leds,0,0);
        ctx.save();ctx.globalCompositeOperation='screen';ctx.globalAlpha=.18;ctx.filter='blur(2px)';ctx.drawImage(leds,0,0);ctx.restore();
      }
      root.querySelector('.gb-device').classList.toggle('gb-is-on',powered);
      canvas.setAttribute('aria-label',powered?'Illuminated 64 by 64 LED design preview':'LED display switched off');
    }
    function pattern(mode){
      c.fillStyle='#000';c.fillRect(0,0,64,64);
      c.imageSmoothingEnabled=false;
      if(mode==='heart'){
        // Four physical LEDs per pixel-art block: crisp, symmetric stepped edges.
        const rows=['00111000011100','01111100111110','11111111111111','11111111111111','11111111111111','11111111111111','01111111111110','00111111111100','00011111111000','00001111110000','00000111100000','00000011000000'];
        rows.forEach((row,y)=>[...row].forEach((on,x)=>{
          if(on==='0')return;
          c.fillStyle=y<3?'#ff78c5':y<7?'#ff4db5':'#ff3299';
          c.fillRect(4+x*4,8+y*4,4,4);
        }));
      }else if(mode==='bolt'){
        const rows=['000000001100','000000011100','000000111000','000001111000','000011110000','000111110000','001111111110','011111111100','000001111000','000001110000','000011100000','000011000000','000110000000','000100000000'];
        rows.forEach((row,y)=>[...row].forEach((on,x)=>{if(on==='1'){c.fillStyle=y<6?'#fff19b':'#ff914a';c.fillRect(8+x*4,4+y*4,4,4);}}));
      }else{
        [20,32,44,36,48,40,28,36].forEach((h,i)=>{
          for(let y=55;y>55-h;y-=4){c.fillStyle=y<25?'#80ffed':y<39?'#b891ff':'#ff69c6';c.fillRect(5+i*7,y,5,3);}
        });
      }
      render();
    }
    function turnOn(){powered=true;power.setAttribute('aria-pressed','true');power.textContent='Display on';}
    function choose(button){
      uploadVersion++;
      root.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
      input.value='';remove.hidden=true;status.textContent='';turnOn();pattern(button.dataset.mode);
    }
    root.querySelectorAll('[data-mode]').forEach(button=>button.addEventListener('click',()=>choose(button)));
    remove.addEventListener('click',()=>{choose(root.querySelector('[data-mode=heart]'));status.textContent='Photo removed.';});
    power.addEventListener('click',()=>{powered=!powered;power.setAttribute('aria-pressed',String(powered));power.textContent=powered?'Display on':'Display off';render();});
    input.addEventListener('change',event=>{
      const file=event.target.files[0];if(!file)return;
      if(!file.type.startsWith('image/')||file.size>15*1024*1024){status.textContent='Choose an image smaller than 15 MB.';input.value='';return;}
      const version=++uploadVersion,url=URL.createObjectURL(file),img=new Image();
      status.textContent='Loading your photo…';
      img.onload=()=>{
        if(version===uploadVersion && root.isConnected){
          // Contain instead of crop: the entire uploaded design stays visible.
          const scale=64/Math.max(img.width,img.height),w=Math.max(1,Math.round(img.width*scale)),h=Math.max(1,Math.round(img.height*scale));
          c.fillStyle='#000';c.fillRect(0,0,64,64);c.imageSmoothingEnabled=true;c.imageSmoothingQuality='high';
          c.drawImage(img,Math.floor((64-w)/2),Math.floor((64-h)/2),w,h);
          root.querySelectorAll('[data-mode]').forEach(b=>b.setAttribute('aria-pressed','false'));
          turnOn();render();remove.hidden=false;status.textContent='Your photo is ready.';
        }
        URL.revokeObjectURL(url);input.value='';
      };
      img.onerror=()=>{if(version===uploadVersion)status.textContent='Try another image, such as a JPG or PNG.';URL.revokeObjectURL(url);input.value='';};
      img.src=url;
    });
    pattern('heart');
  }
  function initAll(scope){scope.querySelectorAll('.gb-story').forEach(init);}
  initAll(document);
  document.addEventListener('shopify:section:load',event=>initAll(event.target));
})();
